module.exports = __webpack_public_path__ + "media/images/front/pc/dummy/doctor03-658d1bd6276b82aef66ac73dabd193bf.png";